// extracted by mini-css-extract-plugin
export var info_blurb = "author-bio-module--info_blurb--BURUX";